import { int, oneOf, text } from '@/hooks/useUrlState';

/**
 * The `type` values of the discount types Go offers (`discountTypes`, `Go/internal/catalog/domain.go`); the Select
 * options come from that query, so a type added there needs its value here to be accepted from the URL.
 */
export const DISCOUNT_TYPE_SET = {
  percentage: true,
  fixed_amount: true,
} as const;

export type DiscountTypeFilter = keyof typeof DISCOUNT_TYPE_SET | '';

/** The /discounts query string, in this order (see README "List pages, URL state"). */
export const discountsUrlSchema = {
  search: text(),
  type: oneOf(DISCOUNT_TYPE_SET, ''),
  page: int({ min: 1 }, 1),
  size: int({ min: 1, max: 500 }, 25),
};

/** The keys that live in the collapsible Filters panel: it opens on mount when `type` is set. */
export const DISCOUNTS_ADVANCED_KEYS = ['type'] as const satisfies readonly (keyof typeof discountsUrlSchema)[];
